import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QuoteService } from 'src/app/service/quote.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddressModel, GetQuoteResponseModel, MemberModel, MetadataModel, PhoneModel } from 'src/app/service/web-api-client';

@Component({
  selector: 'app-quote-step11-desktop',
  templateUrl: './quote-step11-desktop.component.html',
  styleUrls: ['./quote-step11-desktop.component.css']
})
export class QuoteStep11DesktopComponent implements OnInit {
  ballPink1srcNew: string = '/assets/external/newbasketball-resize.png'
  vectorUnFilled: string = '/assets/external/vector3387-ovts.svg'
  vectorfilled: string = '/assets/external/vector3387-ynbm.svg'
  towerNew: string = '/assets/external/tower-new-resize.png'
  @Input()
  ellipse25src3: string = '/assets/external/ellipse253402-ia3i.svg'
  @Input()
  vectoralt10: string = 'VectorI3402'
  @Input()
  rootClassName: string = ''
  @Input()
  vectoralt13: string = 'VectorI3402'
  @Input()
  inputplaceholder1: string = 'Amador Montoya'
  @Input()
  vectorsrc5: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/d95a743c-9f40-4772-9ff4-fdfffb9e91bb?org_if_sml=11330&force_format=original'
  @Input()
  inputplaceholder3: string = 'Amador Montoya'
  @Input()
  vectorsrc2: string = '/assets/external/vector3402-78ns.svg'
  @Input()
  vectoralt: string = 'Vector3402'
  @Input()
  ellipse25src1: string = '/assets/external/ellipse253402-jpme.svg'
  @Input()
  vectorsrc4: string = '/assets/external/vector3402-eum.svg'
  @Input()
  vectorsrc6: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/80ba0374-43c3-46e1-ae4a-a99124a1843d?org_if_sml=1624&force_format=original'
  @Input()
  ellipse25alt1: string = 'Ellipse253402'
  @Input()
  vectorsrc14: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/78c749c6-eb2b-4837-b53a-087b31cf5d13?org_if_sml=1740&force_format=original'
  @Input()
  vectorsrc: string = '/assets/external/vector3402-9mim.svg'
  @Input()
  vectorsrc11: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/8de196a5-7f0e-4960-b87e-59fc39334f0b?org_if_sml=1744&force_format=original'
  @Input()
  inputplaceholder4: string = '114040276'
  @Input()
  vectoralt12: string = 'VectorI3402'
  @Input()
  ellipse25alt4: string = 'Ellipse253402'
  @Input()
  vectoralt1: string = 'Vector3402'
  @Input()
  inputplaceholder2: string = 'Andrea'
  @Input()
  ellipse25src: string = '/assets/external/ellipse253402-v71v.svg'
  @Input()
  vectoralt4: string = 'Vector3402'
  @Input()
  vectoralt3: string = 'Vector3402'
  @Input()
  vectorsrc12: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/fea2af4d-7b0f-4520-9494-9178de93270f?org_if_sml=1743&force_format=original'
  @Input()
  vectoralt15: string = 'VectorI3402'
  @Input()
  vectorsrc8: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/eb8d561a-744b-45ac-ad5a-4b3196e33dc3?org_if_sml=1503&force_format=original'
  @Input()
  vectoralt11: string = 'VectorI3402'
  @Input()
  vectorsrc13: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/24903efc-01b1-4d02-840b-7339d39ced71?org_if_sml=1222&force_format=original'
  @Input()
  vectoralt5: string = 'VectorI3402'
  @Input()
  vectorsrc15: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/15d9c5c9-e87f-437f-9f15-8f6639d32c72?org_if_sml=1490&force_format=original'
  @Input()
  ellipse25alt3: string = 'Ellipse253402'
  @Input()
  vectorsrc1: string = '/assets/external/vector3402-5wl.svg'
  @Input()
  ellipse25alt: string = 'Ellipse253402'
  @Input()
  vectorsrc3: string = '/assets/external/vector3402-5v6a.svg'
  @Input()
  vectorsrc7: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/8a6d8d5e-6a12-473e-8ccc-2a00a68a352d?org_if_sml=1171&force_format=original'
  @Input()
  ellipse25alt2: string = 'Ellipse253402'
  @Input()
  ellipse25src2: string = '/assets/external/ellipse253402-c4cg.svg'
  @Input()
  vectoralt14: string = 'VectorI3402'
  @Input()
  vectorsrc10: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/2f8d88dd-c103-41a9-82a9-227b0229565f?org_if_sml=1517&force_format=original'
  @Input()
  vectoralt8: string = 'VectorI3402'
  @Input()
  vectorsrc9: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/4d1161da-5cd3-42c8-ae39-46274b6ded7f?org_if_sml=1633&force_format=original'
  @Input()
  inputplaceholder: string = 'Andrea'
  @Input()
  vectoralt2: string = 'Vector3402'
  @Input()
  vectoralt6: string = 'VectorI3402'
  @Input()
  ellipse25src4: string = '/assets/external/ellipse253402-srkj.svg'
  @Input()
  vectoralt7: string = 'VectorI3402'
  @Input()
  vectoralt9: string = 'VectorI3402'

  @Input() screenWidth: number;
  @Input() currentStep: number;
  @Output() onNextStep: EventEmitter<number> = new EventEmitter();
  @Output() onPrevStep: EventEmitter<number> = new EventEmitter();

  constructor(private quoteService: QuoteService, private fb: FormBuilder,) {
    this.createForm();
  }
  stepElevenForm: FormGroup;
  submitted = false;
  lastYear: number = new Date().getFullYear()
  loading: boolean = false;
  certificateError: boolean = false;


  createForm() {
    this.stepElevenForm = this.fb.group({
      dayBirth: [null, [Validators.required, Validators.min(1), Validators.max(31), Validators.pattern(/^[0-9]*$/) ]],
      monthBirth: [null, [Validators.required, Validators.min(1), Validators.max(12), Validators.pattern(/^[0-9]*$/) ]],
      yearBirth: [null, [Validators.required, Validators.min(1900), Validators.max(this.lastYear), Validators.pattern(/^[0-9]*$/) ]],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      pasaportNo: ['', Validators.required],
      relationship: ['', Validators.required],
      memberId: [''],
    });
  }

  formatTwoDigits(number) {
    return number.toString().padStart(2, '0');
  }

  formatDateToDDMMYYYY(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  private getMemberKey(member: MemberModel): string {
    if (member?.memberId && member.memberId > 0) {
      return `id-${member.memberId}`;
    }
    const firstName = (member?.firstName || '').trim().toLowerCase();
    const lastName = (member?.lastName || '').trim().toLowerCase();
    const passportNumber = (member?.passportNumber || '').trim().toLowerCase();
    const birthdate = (member?.birthdate || '').trim();
    return `temp-${firstName}-${lastName}-${passportNumber}-${birthdate}`;
  }

  private getMemberType(member: MemberModel): number {
    if (!member) {
      return 0;
    }
    return member.memberTypeId || member.memberType?.id || 0;
  }

  private assignMemberType(member: MemberModel, memberTypeId: number, isDependent: boolean): void {
    if (!member) {
      return;
    }
    member.memberTypeId = memberTypeId;
    if (member.memberType) {
      member.memberType.id = memberTypeId;
    }
    member.isDependent = isDependent;
  }

  private sanitizeMember(member: MemberModel): MemberModel {
    if (!member) {
      return member;
    }

    const sanitized = new MemberModel(member);
    sanitized.phones = (sanitized.phones || [])
      .map(phone => new PhoneModel(phone))
      .map(phone => {
        const typeId = phone.phoneTypeId || phone.phoneType?.id || 0;
        phone.phoneTypeId = typeId;
        if (phone.phoneType) {
          phone.phoneType.id = typeId;
        }
        return phone;
      })
      .filter(phone => phone.phoneTypeId === 1 || phone.phoneTypeId === 2);

    return sanitized;
  }

  private upsertMember(updatedMember: MemberModel): MemberModel[] {
    const members = [...(this.quoteService.quoteModel?.members || [])].map(member => this.sanitizeMember(member));
    const sanitizedMember = this.sanitizeMember(updatedMember);
    const updatedType = this.getMemberType(sanitizedMember);
    const updatedMemberId = sanitizedMember?.memberId;
    this.assignMemberType(sanitizedMember, updatedType, updatedType === 2);

    const filteredMembers = members.filter(existingMember => {
      if (!existingMember) {
        return false;
      }
      if (updatedMemberId && updatedMemberId > 0) {
        return existingMember.memberId !== updatedMemberId;
      }
      if (updatedType === 1 && this.getMemberType(existingMember) === 1) {
        return false;
      }
      if (!updatedMemberId && !existingMember.memberId && this.getMemberType(existingMember) === updatedType) {
        const sameIdentity =
          existingMember.firstName === updatedMember.firstName &&
          existingMember.lastName === updatedMember.lastName &&
          existingMember.passportNumber === updatedMember.passportNumber &&
          existingMember.birthdate === updatedMember.birthdate;
        return !sameIdentity;
      }
      return true;
    });

    filteredMembers.push(sanitizedMember);
    return this.sortMembers(filteredMembers);
  }

  private mergeMembers(existingMembers: MemberModel[], apiMembers: MemberModel[]): MemberModel[] {
    const memberMap = new Map<string, MemberModel>();

    const addOrUpdate = (member: MemberModel, isApiMember = false) => {
      if (!member) {
        return;
      }
      const normalizedMember = this.sanitizeMember(member);
      const memberType = this.getMemberType(normalizedMember);
      if (memberType > 0) {
        normalizedMember.memberTypeId = memberType;
      }
      const key = this.getMemberKey(normalizedMember);
      if (!memberMap.has(key) || isApiMember) {
        memberMap.set(key, normalizedMember);
      }
    };

    (existingMembers || []).forEach(member => addOrUpdate(member));
    (apiMembers || []).forEach(member => addOrUpdate(member, true));

    return this.sortMembers(Array.from(memberMap.values()));
  }

  private sortMembers(members: MemberModel[]): MemberModel[] {
    const priorityMap: Record<number, number> = {
      1: 0,
      2: 1,
      3: 2
    };

    return members
      .filter(member => !!member)
      .sort((memberA, memberB) => {
        const weightA = priorityMap[this.getMemberType(memberA)] ?? 99;
        const weightB = priorityMap[this.getMemberType(memberB)] ?? 99;

        if (weightA !== weightB) {
          return weightA - weightB;
        }

        const memberIdA = memberA.memberId ?? Number.MAX_SAFE_INTEGER;
        const memberIdB = memberB.memberId ?? Number.MAX_SAFE_INTEGER;
        return memberIdA - memberIdB;
      });
  }

  handleSubmit(): void {
    this.submitted = true;
    if (this.stepElevenForm.valid) {
      document.getElementById('genrateLoadingModalToggle').click();
      this.loading = true;
      const self = this;
      const formValues = this.stepElevenForm.value
      const memberId = this.stepElevenForm.value.memberId;
      let member = new MemberModel({
        firstName: formValues.firstName,
        lastName: formValues.lastName,
        passportNumber: formValues.pasaportNo,
        relation: formValues.relationship,
        memberTypeId: 3,
        countryId: formValues.pais,
        birthdate: `${formValues.yearBirth}-${this.formatTwoDigits(formValues.monthBirth)}-${this.formatTwoDigits(formValues.dayBirth)}`,
        email: this.quoteService.quoteModel.members[0].email,
        isDependent: false,
      });
      this.assignMemberType(member, 3, false);
      member.phones = [];
      if(this.quoteService.quoteModel.members[0].address){
        member.address = new AddressModel({
          address1: this.quoteService.quoteModel.members[0].address.address1,
          state: this.quoteService.quoteModel.members[0].address.state,
          city: this.quoteService.quoteModel.members[0].address.city,
          postalCode: this.quoteService.quoteModel.members[0].address.postalCode,
        })
      }
      const parsedMemberId = Number(memberId);
      if (!isNaN(parsedMemberId) && parsedMemberId > 0) {
        member.memberId = parsedMemberId;
      } else {
        member.memberId = 0;
      }

      // Initialize phones array (beneficiaries don't have phones)
      member.phones = [];

      // Get the owner (memberTypeId = 1) - it must always be included in the API call
      const owner = (this.quoteService.quoteModel?.members || []).find(m => 
        (m.memberTypeId === 1 || m.memberType?.id === 1)
      );

      if (!owner) {
        this.loading = false;
        document.getElementById('genrateLoadingModalToggle').click();
        console.error('Owner member not found. Cannot proceed without owner.');
        return;
      }

      // Get all existing dependents (memberTypeId = 2) - they must also be included
      const existingDependents = (this.quoteService.quoteModel?.members || []).filter(m => {
        const memberType = m.memberTypeId || m.memberType?.id || 0;
        return memberType === 2;
      });

      // Get any existing beneficiaries (memberTypeId = 3) except the one being updated
      const existingBeneficiaries = (this.quoteService.quoteModel?.members || []).filter(m => {
        const memberType = m.memberTypeId || m.memberType?.id || 0;
        return memberType === 3 && m.memberId !== member.memberId;
      });

      // Ensure owner + all dependents + existing beneficiaries + new/updated beneficiary are included
      const sanitizedOwner = this.sanitizeMember(owner);
      const sanitizedDependents = existingDependents.map(d => this.sanitizeMember(d));
      const sanitizedBeneficiaries = existingBeneficiaries.map(b => this.sanitizeMember(b));
      const sanitizedBeneficiary = this.sanitizeMember(member);
      this.assignMemberType(sanitizedBeneficiary, 3, false);
      sanitizedBeneficiary.phones = [];

      // Create members array: owner + dependents + existing beneficiaries + new/updated beneficiary
      const membersToSend = [
        sanitizedOwner,
        ...sanitizedDependents,
        ...sanitizedBeneficiaries,
        sanitizedBeneficiary
      ];

      // Create a temporary quote model with all required members
      const tempQuoteModel = new GetQuoteResponseModel({
        ...this.quoteService.quoteModel,
        members: membersToSend
      });

      const membersToPersist = [...membersToSend];
      this.quoteService.updateCertificate$(tempQuoteModel).subscribe(r => {
        const resultJson = JSON.stringify(r);
            const result = JSON.parse(resultJson);
            try {
              const mergedMembers = this.mergeMembers(membersToPersist, result.members);
              self.quoteService.quoteModel = result;
              self.quoteService.quoteModel.members = mergedMembers;
              // self.onNextStep.emit(self.currentStep); //Do not checkin
              this.quoteService.submitCertificate$(this.quoteService.quoteModel).subscribe(r => {
                document.getElementById('genrateLoadingModalToggle').click();
                self.onNextStep.emit(self.currentStep);  
                
              }, error => {
                console.log('error', error,error.title);
                document.getElementById('genrateLoadingModalToggle').click();
                self.certificateError= true
              })     
              this.loading = false;         
            } catch (error) {
              console.log('error', error);
              document.getElementById('genrateLoadingModalToggle').click();
              this.loading = false;
            }
            
            return result;
        // if (r.members.length > 0) {
        //   const lastMember = r.members[r.members.length - 1];
        //   r.metadata = [new MetadataModel(
        //     {
        //       key: 'beneficiaryId',
        //       value: lastMember.memberId.toString(),
        //     })]
        //   r.members = []
        //   self.quoteService.updateQuote$(r).subscribe(r => {
        //     const resultJson = JSON.stringify(r);
        //     const result = JSON.parse(resultJson);
        //     try {
        //       console.log('resultresult', result);
        //       self.quoteService.quoteModel = result;
        //       console.log(self.quoteService.quoteModel);
        //       self.onNextStep.emit(self.currentStep);
        //     } catch (error) {
        //       console.log('error', error);
        //     }
        //     return result;
        //   });
        // }
      });
    }
    
  }

  prevStep(): void {
    if(this.quoteService.quoteModel.dependentCount === 0 && this.quoteService.quoteModel.dependentCountOver65 === null ) {
      console.log('this.currentStep - 1', this.currentStep - 1);
      this.onPrevStep.emit(9);
    } else {
      console.log('this.currentStep', this.currentStep);
      this.onPrevStep.emit(this.currentStep);
    }
    this.onPrevStep.emit(this.currentStep);
  }

  ngOnInit() {
    if (this.quoteService.quoteModel) {
      if(this.quoteService.quoteModel.metadata.length > 0){
        const beneficiaryId = this.quoteService.quoteModel.members.find(m => m.memberTypeId === 3)?.memberId;
        if (beneficiaryId) {
          const getOwner = this.quoteService.quoteModel.members.find(member => member.memberId === beneficiaryId);
          if (getOwner) {
            this.stepElevenForm.controls.firstName.setValue(getOwner.firstName);
            this.stepElevenForm.controls.lastName.setValue(getOwner.lastName);
            this.stepElevenForm.controls.pasaportNo.setValue(getOwner.passportNumber);
            this.stepElevenForm.controls.dayBirth.setValue(this.formatTwoDigits(new Date(getOwner.birthdate).getDay()));
            this.stepElevenForm.controls.monthBirth.setValue(this.formatTwoDigits(new Date(getOwner.birthdate).getMonth() + 1));
            this.stepElevenForm.controls.yearBirth.setValue(new Date(getOwner.birthdate).getFullYear());
            this.stepElevenForm.controls.relationship.setValue(getOwner.relation);
            this.stepElevenForm.controls.memberId.setValue(getOwner.memberId);
          }
        }
      }
    }
  }
}
